import { useCallback, useState } from "react";

/**
 * Utility Hook to easy-manage a boolean state
 * @param initialState
 * @returns
 */
export default function useBoolean(
    initialState: boolean | (() => boolean),
): [boolean, () => void, (boolean) => void] {
    const [state, setState] = useState(initialState);

    // toggle handler
    const toggle = useCallback(() => {
        setState((val) => !val);
    }, [setState]);

    return [state, toggle, setState];
}
